import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ShoppingCartPlusIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M12 10H14V7H17V5H14V2H12V5H9V7H12V10ZM8 19C6.9 19 6.01 19.9 6.01 21C6.01 22.1 6.9 23 8 23C9.1 23 10 22.1 10 21C10 19.9 9.1 19 8 19ZM18 19C16.9 19 16.01 19.9 16.01 21C16.01 22.1 16.9 23 18 23C19.1 23 20 22.1 20 21C20 19.9 19.1 19 18 19ZM9.1 14H16.55C17.3 14 17.96 13.59 18.3 12.97L22.16 5.96L20.42 5L16.55 12H9.53L5.27 3H2V5H4L7.6 12.59L6.25 15.03C5.52 16.37 6.48 18 8 18H20V16H8L9.1 14Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
